import moment from 'moment'
import 'moment/locale/es'


export const HeaderLogoLeft = ({ infoEmp, infoGeneral, dataPreview }) => {

    const { pdf_color_formato, ppto_pdf_nombre_ppto } = infoGeneral
    const { url_foto } = infoEmp

    return (
        <div className='header-pdf'>
            <div className='container-logo'>
                <img
                    src={url_foto}
                    alt="Logo empresa"
                />
            </div>
            <div className='container-folio right'>
                {pdf_color_formato ?
                    <h1 style={{ color: pdf_color_formato }}>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </h1>
                    :
                    <h1 className='default-title'>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </h1>
                }

                <p className='info-folio'>{`#${dataPreview.folio}`}</p>
                <p className='sub-title fecha'>{moment(new Date()).format('DD MMMM YYYY')}</p>

                {(dataPreview?.nro_version_actual > 0) &&
                    <p className='sub-title version'>Versión {dataPreview?.nro_version_actual || 1}</p>
                }

            </div>
        </div>
    )
}